/* eslint-disable react/prop-types */
import SinglePageVerticalProductInfo from 'components/Products/SinglePageVerticalProductInfo'
import SubmitContext from 'context/submit/submitContext'
import React, { useContext, useEffect, useRef } from 'react'
import { Col, Row } from 'reactstrap'
import SubmissionList from 'views/shared/SubmissionList.jsx'
import { FormContext, useForm } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import NotificationAlert from 'react-notification-alert'

const ProductForm = ({
  product: {
    footer,
    model,
    productDesc,
    pricingInfo,
    imagesUpload,
    notice,
    nutritionInfo,
    packagingInfo,
    productTitle,
    validCategories,
    validSubCategories,
    brandSpecific,
  },
}) => {
  const { checkImages } = useFormUtils()

  const submitContext = useContext(SubmitContext)
  const {
    current,
    checkUPCAddProduct,
    updateSubmitterProduct,
    updating,
    products,
    clearCurrent,
    setCurrent,
    setUpdate,
    resetting,
    setResetting,
    replaceProduct,
  } = submitContext

  const methods = useForm()
  const { handleSubmit, reset, setError } = methods

  const notificationAlert = useRef()
  const notify = () => {
    let options = {
      place: 'bc',
      message: (
        <div>
          <div>Your product has been {updating ? 'updated' : 'saved'}.</div>
        </div>
      ),
      type: 'info',
      icon: 'nc-icon nc-bell-55',
      autoDismiss: 7,
    }
    notificationAlert.current.notificationAlert(options)
  }

  console.log('ProductForm brandSpecific: ' + brandSpecific)

  const handleReset = () => {
    reset(
      {
        UPC: '',
        brandName: '',
        productName: '',
        Manufacturer: '',
        distbInCA: false,
        RetailPrice: '',
        FatLevel: '',
        cheeseType: '',
        MadeInUSA: false,
        Kosher: false,
        FishType: '',
        PackedIn: '',
        Grade: '',
        CASEFSCompliantCertification: false,
        EggShellColorCertification: false,
        type: '',
        Type: '',
        otherType: '',
        otherContainerType: '',
        otherPackageType: '',
        size: '',
        Size: '',
        ContainerType: '',
        packageType: '',
        PackageType: '',
        packageSize: '',
        isOrganic: false,
        Organic: false,
        OrganicVerification: false,
        grainLength: '',
        noAddtlIngredients: false,
        NoAdditionalIngredients: false,
        flavor: '',
        Flavor: '',
        otherFlavor: '',
        containerSize: '',
        VitaminCCertification: false,
        OneHundredPercentJuiceCertification: false,
        FrontLabelCertification: false,
        SaltContent: '',
        texture: '',
        milkType: '',
        BreadType: '',
        BreadSize: '',
        GrainSize: '',
        BarleyVerification: false,
        GrainLength: '',
        OatType: '',
        OatVariety: '',
        CookingType: '',
        certification: false,
        MultiPackageType: false,
        MultiPackageCount: '',
        FederalNutrition: false,
        Packaged: '',
        JuiceFlavor: '',
        PBContainerSize: '',
        BeanPeaLentilType: '',
        BeanPeaLentilSize: '',
        PBType: '',
        PBTexture: '',
        otherTexture: '',
        ReducedFatMilkType: '',
        ReducedFatMilkSize: '',
        WholeMilkType: '',
        WholeMilkSize: '',
        ItemType: '',
        otherVariety: '',
        DFType: '',
        DFPackageType: '',
        DFSize: '',
        FrozenPackageCertification: '',
        WholeWheatFlour: false,
        PastaShape: '',
        Calcium: '',
        CalciumCertification: false,
        IsPlainRefrigerated: false,
        Texture: '',
        OtherTexture: '',
        PackageSize: '',
        Sugar: '',
        SugarCertification: false,
        SweetenerCertification: false,
        GrainType: '',
        Iron: '',
        IronCertification: false,
        Kcals: '',
        Folate: '',
        Fiber: '',
        WholeGrainPercentage: '',
        WholeGrain: '',
        Sucrose: '',
        Rounding: false,
        UnderIronLimit: false,
        UnderSucroseLimit: false,
        ContainsNoSweeteners: false,
        MilkType: '',
        OtherMilkType: null,
        Protein: '',
        ProteinCertification: false,
        PlantYogurtAltType: '',
        OtherPlantYogurtAltType: null,
        OtherFlavor: null,
        PlantCheeseAltType: '',
        OtherPlantCheeseAltType: null,
        OtherType: null,
        Form: '',
        VitaminA: '',
        VitaminACertification: false,
        VitaminD: '',
        VitaminDCertification: false,
        VitaminB12: '',
        VitaminB12Certification: false,
        Magnesium: '',
        MagnesiumCertification: false,
        Phosphorus: '',
        PhosphorusCertification: false,
        Potassium: '',
        PotassiumCertification: false,
        Riboflavin: '',
        RiboflavinCertification: false,
        FDACert: false,
        Variety: '',
        OtherVariety: null,
        WholeGrainCert: false,
        WholeWheatCert: false,
        Color: '',
      },
      {
        errors: false, // errors will not be reset
        dirtyFields: false, // dirtyFields will not be reset
        dirty: false, // dirty will not be reset
        isSubmitted: false,
        touched: false,
        isValid: false,
        submitCount: false,
      }
    )
  }

  const onSubmit = async data => {
    console.log('JSON.stringify(current) is: ' + JSON.stringify(current))
    console.log('current in ProductForm is: ' + JSON.stringify(current))
    if (checkImages(current.images)) {
      if (updating) {
        current.UPC === current.oldUPC
          ? updateSubmitterProduct(current)
          : await replaceProduct(current)
      } else {
        checkUPCAddProduct(current)
      }
      console.log('products is: ' + JSON.stringify(products))
      console.log('data is: ' + JSON.stringify(data))
      notify()
    } else {
      setError(
        'ImagesUpload',
        'missingImage',
        '⚠ An image is required for submission.'
      )
    }
    // if (!checkImages(current.images)) {
    //   setError(
    //     'ImagesUpload',
    //     'missingImage',
    //     '⚠ An image is required for submission.'
    //   )
    // } else {
    //   if (updating) {
    //     current.UPC === current.oldUPC
    //       ? updateSubmitterProduct(current)
    //       : await replaceProduct(current)
    //   } else {
    //     checkUPCAddProduct(current)
    //   }
    //   console.log('products is: ' + JSON.stringify(products))
    //   console.log('data is: ' + JSON.stringify(data))
    // }
  }

  useEffect(() => {
    if (resetting) {
      setResetting(false)
      clearCurrent()
      handleReset()
      setCurrent(model)
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetting])

  useEffect(() => {
    console.log('setting model')
    setCurrent(model)
    setUpdate(false)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="content">
      <NotificationAlert ref={notificationAlert} />
      <FormContext {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} className={'Form'}>
          <Row>
            <Col md={12}>
              <SinglePageVerticalProductInfo
                productDesc={productDesc}
                pricingInfo={pricingInfo}
                imagesUpload={imagesUpload}
                notice={notice}
                nutritionInfo={nutritionInfo}
                packagingInfo={packagingInfo}
                productTitle={productTitle}
                model={model}
                brandSpecific={brandSpecific}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <SubmissionList
                productTitle={productTitle}
                category={model.category}
                subCategory={model.subCategory}
                model={model}
                validCategories={validCategories}
                validSubCategories={validSubCategories}
              />
            </Col>
          </Row>
          {footer || null}
        </form>
      </FormContext>
    </div>
  )
}

export default ProductForm
